import styled from 'styled-components';

import InputDebounced from 'components/lib/InputDebounced';

export const TableFilterBarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TableFilterBarFilters = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const TableFilterBarResetContainer = styled.div`
  flex-shrink: 0;
  padding: 0 10px;
  margin: 0 5px;
  border-left: 1px solid var(--line-gray);
`;

export const TableFilterBarReset = styled.span`
  color: var(--text-secondary);
  font-size: 10px;
  cursor: pointer;
`;

export const TableFilterBarSearch = styled(InputDebounced)`
  width: 380px;
`;
